import { useMutation, UseMutationResult } from 'react-query'
import postGiftRedeemEGift, {
    TEGiftQueryResult,
} from '@/src/common/queries/PostGiftRedeemEGift'

const usePostRedeemEgift = (): UseMutationResult<TEGiftQueryResult> => {
    return useMutation('postGiftRedeemEGift', postGiftRedeemEGift)
}

export default usePostRedeemEgift
